import { Media } from '@bpm-web-app/download-api-sdk';
import classNames from 'classnames';
import { isDownloadLimitReached } from '@bpm-web-app/utils';
import styles from './versions-column.module.css';
import ArrowDownTriangle from '../../../../assets/icons/arrow-down-triangle.svg';
import DownloadIcon from '../../../../assets/icons/download.svg';

interface VersionsColumnProps {
    versionsList: Media[];
    onMoreVersionsClick?: () => void;
    onVersionClick?: (version: Media) => void;
    isAccordionOpen: boolean;
}

export function getVersionPillLabel(version: string) {
    return version
        .split(' ')
        .slice(0, 3)
        .map((c) => c.charAt(0).toUpperCase());
}
const pillsLimit = 4;

function VersionsColumn({ versionsList, onMoreVersionsClick, onVersionClick, isAccordionOpen }: VersionsColumnProps) {
    return (
        <div className={classNames('hide-filters-open', styles['versions-column'])}>
            {versionsList.slice(0, pillsLimit).map((media) => (
                <button
                    type="button"
                    key={media.id}
                    className={classNames(styles['versions-column__pill'], { [styles['versions-column__pill__downloaded']]: media.download_count })}
                    disabled={isDownloadLimitReached(media.download_count)}
                    data-tip={media.version?.name}
                    onClick={(e) => {
                        e.stopPropagation();
                        onVersionClick?.(media);
                    }}>
                    <span className={styles['versions-column__pill__text']}>
                        {getVersionPillLabel(media.version?.name)}
                    </span>
                    <span className={styles['versions-column__pill__download']}>
                        <DownloadIcon />
                    </span>
                </button>
            ))}
            {versionsList.length > pillsLimit && (
                <button
                    type="button"
                    className={classNames(styles['versions-column__more-versions-btn'], { [styles['versions-column__more-versions-btn--open']]: isAccordionOpen })}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMoreVersionsClick?.();
                    }}
                >
                    {`+${versionsList.length - pillsLimit} More`}
                    <ArrowDownTriangle />
                </button>
            )}
        </div>
    );
}
export default VersionsColumn;
